var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"page-title"},[_vm._v(" Mobile Issues ")]),_c('Widget',{},[_c('b-button',{attrs:{"to":{ name: 'NewPage'},"variant":"info"}},[_vm._v("Add Website")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }